module.exports = __webpack_public_path__ + "static/media/IlotD_synthese_16.21bd104e.webp";